import React from 'react'
import { Link } from "react-router-dom";
import { CopyToClipboard } from 'react-copy-to-clipboard'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import SearchUI from '../../../widgets/input/SearchUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import './NodalTxnList.css'

const EscrowTxnListUI = ({ context, transactionList, onRefreshClick, accountNumber,
  searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText,
  details, onDetailsClick, onDownloadEsccTxnsClick
}) =>
  <div className='su_ntxn'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
          onDownloadEsccTxnsClick={onDownloadEsccTxnsClick}
          accountNumber={accountNumber}
        />
      }
      right={
        <ActionRightUI
          context={context}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    {
      transactionList.length === 0 &&
      <EmptyListUI
        context={context}
        createEnabled={false}
        createDisabledMessageLabel='No transactions'
      />
    }

    {
      transactionList.length > 0 &&
      <div className='g_flex_h'>
        <div className='g_flex_h g_m_bottom_25'>
          <Link to='#' onClick={onDetailsClick}>Details</Link>
        </div>
        <span>{transactionList.length} transaction{transactionList.length == 1 ? '' : 's'} displayed</span>
      </div>
    }

        {
          transactionList.length > 0 &&
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Details</th>
                <th>Credit</th>
                <th>Debit</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {
                !context.permissions.includes('su_superuser') &&
                transactionList.filter(txn => txn.climeTxnType !== 'salary_paid' && txn.climeTxnType !== 'employee_payment').map((txn, i) =>
                  <TxnRowList key={i} context={context} txn={txn}
                    onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                    details={details}
                  />
                )
              }
              {
                context.permissions.includes('su_superuser') &&
                transactionList.map((txn, i) =>
                  <TxnRowList key={i} context={context} txn={txn}
                    onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
                    details={details}
                  />
                )
              }
            </tbody>
          </table>
        }
      </div>

const TxnRowList = ({context, txn, details, onCopyToClipboard, copyToClipboardText
    }) =>
    <tr>
      <td className='g_text_top g_small'>
        <span className='g_no_wrap_2'>{txn.transactionDateF}</span>
      </td>
      <td className='g_text_top g_p_left_50 g_small'>
        <RowLeftUI context={context} txn={txn} details={details}
          onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        />
      </td>
      <td className='g_text_top g_text_right g_p_left_50 g_small'>
        {
          txn.amount >= 0 &&
          <span>{txn.amountF1}</span>
        }

      </td>
      <td className='g_text_top g_text_right g_p_left_50 g_small'>
        {
          txn.amount < 0 &&
          <span>({txn.amountF1})</span>
        }
      </td>
      <td className='g_text_top g_text_right g_p_left_50 g_small'>
        {txn.balanceAmountF1}
      </td>
    </tr>

    const RowLeftUI = ({txn, onCopyToClipboard, copyToClipboardText, details}) =>
    <div className='g_flex_v'>
      <span className='particulars'>
        <span>{txn.particulars}</span>
      </span>
      {
        details &&
        <>
          <span className='g_muted'>{txn.remarks}</span>
          <span className='g_muted'>{txn.depositBranch}</span>
          <span className=''>
            <span className='g_muted'>{txn.iciciTransactionId}</span>
            <span onClick={e => e.stopPropagation()}>
              <CopyToClipboard text={txn.iciciTransactionId}
                onCopy={onCopyToClipboard}>
                <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
              </CopyToClipboard>
              {
                copyToClipboardText === txn.iciciTransactionId &&
                <span className='g_m_left_50 g_muted'>copied</span>
              }
            </span>
          </span>
          {
            txn.appTxnId &&
            <span className='g_small g_muted'>
              Escrow a/c: {txn.escrowAccountNumber}
              <span className='g_m_left_50'>{txn.appTxnId}</span>
            </span>
          }
          {
            txn.loanId &&
            <span className='g_muted g_small'>Loan: {txn.loanId} {txn.loanName}</span>
          }
        </>
      }
      <span className='g_flex_h g_flex_left'>
        {
          txn.climeTxnType &&
          <span className='g_m_top_25'>
            <BadgeUI label={txn.climeTxnType} />
          </span>
        }
        {
          txn.type &&
          <span className='g_m_top_25'>
            <BadgeUI label={txn.type} />
            <span className='g_m_left_50'><b>{txn.accountName}</b></span>
            {
              txn.remitter &&
              <span className='g_m_left_50 icon icon-angle-left'> {txn.remitter}</span>
            }
            {
              txn.payee &&
              <span className='g_m_left_50 icon icon-angle-right'> {txn.payee}</span>
            }
          </span>
        }
      </span>
      {
        txn.internalRemarks &&
        <span className='g_muted'>Remarks: {txn.internalRemarks}</span>
      }
    </div>

    const ActionLeftUI = ({onRefreshClick, onDownloadEsccTxnsClick, accountNumber}) =>
    <div className='g_flex_h'>
      <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
      <IconButtonUI icon='icon-download' onClick={onDownloadEsccTxnsClick} />
      <span className='g_m_left_100 g_large'><b>Collection Account {accountNumber}</b></span>
    </div>

    const ActionRightUI = ({searchFilter, onSearchFilterChange}) =>
    <div className='g_flex_h'>
      <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    </div>

    export default EscrowTxnListUI
